import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class DoctorCompensationAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  getContracts = ApiRoutes.DoctorCompensation.GetContracts
  newContract = ApiRoutes.DoctorCompensation.NewContract
  activeProviders = ApiRoutes.DoctorCompensation.ActiveProviders
  contractDoctors = ApiRoutes.DoctorCompensation.ContractDoctors
  editContract = ApiRoutes.DoctorCompensation.EditContract
  removeContract = ApiRoutes.DoctorCompensation.RemoveContract
  availableYears = ApiRoutes.DoctorCompensation.AvailableYears
  qboMemo = ApiRoutes.DoctorCompensation.QboMemo
  summaryMemo = ApiRoutes.DoctorCompensation.SummaryMemo
  docSummary = ApiRoutes.DoctorCompensation.DocSummary
  payroll = ApiRoutes.DoctorCompensation.Payroll
  labExpenses = ApiRoutes.DoctorCompensation.LabExpenses
  journalEntries = ApiRoutes.DoctorCompensation.JournalEntries

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getDoctorCompensation = (
    token: string,
    group_sk: string,
    region: string,
    practice_sk: any,
    doctorName: any,
    status: any,
  ) => {
    return this.instance({
      method: this.getContracts.Method,
      url: this.getContracts.EndPoint(
        group_sk,
        region,
        practice_sk,
        doctorName,
        status,
      ),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  createContract = (token: string, payload: any) => {
    return this.instance({
      method: this.newContract.Method,
      url: this.newContract.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { ...payload },
    })
  }

  getActiveProviders = (
    token: string,
    group_sk: any,
    region: any,
    practice_sk: any,
  ) => {
    return this.instance({
      method: this.activeProviders.Method,
      url: this.activeProviders.EndPoint(group_sk, region, practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getContractDoctors = (
    token: string,
    group_sk: any,
    region: any,
    practice_sk: any,
  ) => {
    return this.instance({
      method: this.contractDoctors.Method,
      url: this.contractDoctors.EndPoint(group_sk, region, practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  updateContract = (token: string, comp_plan_id: any, payload: any) => {
    return this.instance({
      method: this.editContract.Method,
      url: this.editContract.EndPoint(comp_plan_id),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { ...payload },
    })
  }

  deleteContract = (token: string, comp_plan_id: any) => {
    return this.instance({
      method: this.removeContract.Method,
      url: this.removeContract.EndPoint(comp_plan_id),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getAvailableYears = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.availableYears.Method,
      url: this.availableYears.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getQboMemo = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.qboMemo.Method,
      url: this.qboMemo.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getSummaryMemo = (token: string, practice_sk: any) => {
    return this.instance({
      method: this.summaryMemo.Method,
      url: this.summaryMemo.EndPoint(practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getDoctorSummary = (
    token: string,
    group_sk: any,
    region: any,
    practice_sk: any,
    year: any,
    month: any,
    memo: any,
  ) => {
    return this.instance({
      method: this.docSummary.Method,
      url: this.docSummary.EndPoint(group_sk, region, practice_sk, year, memo),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_sk: group_sk,
        region: region,
        practice_sk: practice_sk,
        year: year,
        month_list: month,
        memo: memo,
      },
    })
  }
  getDoctorPayroll = (
    token: string,
    group_sk: any,
    region: any,
    practice_sk: any,
    year: any,
    month: any,
    memo: any,
  ) => {
    return this.instance({
      method: this.payroll.Method,
      url: this.payroll.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_sk: group_sk,
        region: region,
        practice_sk: practice_sk,
        year: year,
        month_list: month,
        memo: memo,
      },
    })
  }
  getLabExpenses = (
    token: string,
    group_sk: any,
    region: any,
    practice_sk: any,
    year: any,
    month: any,
    memo: any,
  ) => {
    return this.instance({
      method: this.labExpenses.Method,
      url: this.labExpenses.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_sk: group_sk,
        region: region,
        practice_sk: practice_sk,
        year: year,
        month_list: month,
        memo: memo,
      },
    })
  }
  getJournalEntries = (
    token: string,
    group_sk: any,
    region: any,
    practice_sk: any,
    year: any,
    month: any,
    memo: any,
  ) => {
    return this.instance({
      method: this.journalEntries.Method,
      url: this.journalEntries.EndPoint(
        group_sk,
        region,
        practice_sk,
        year,
        month,
        memo,
      ),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
}
